import { api } from "../lib/api";
import { Icon } from "./icons";

const norm = (s) => (s || "").trim().toLocaleLowerCase("pt").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
export const findProject = (projects, name) => projects.find((p) => norm(p.name) === norm(name));

/** Resolves a typed project name: an existing project with the same name (ignoring case/accents) or a new one. */
export async function resolveProjectId(projects, name) {
  const n = (name || "").trim();
  if (!n) return null;
  const hit = findProject(projects, n);
  if (hit) return hit.id;
  try {
    const r = await api("/admin/projects", { method: "POST", body: JSON.stringify({ name: n }) });
    return r.id;
  } catch (err) {
    if ([404, 405].includes(err.status)) throw new Error(`O projeto «${n}» não existe e o servidor do coro ainda não permite criar projetos novos (pendente no backend Mobile). Escolha um projeto existente ou deixe em branco.`);
    throw err;
  }
}

/** Free-text project with suggestions from the shared list. */
export function ProjectField({ projects, value, onChange }) {
  const hit = findProject(projects, value);
  const suggestions = projects.filter((p) => !value.trim() || (norm(p.name).includes(norm(value)) && p !== hit));
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div className="t-section">Projeto</div>
      <input className="input" value={value} onChange={(e) => onChange(e.target.value)} list="ulc-projects" placeholder="Escreva ou escolha um projeto (opcional)" maxLength={80} data-testid="song-project-input" />
      <datalist id="ulc-projects">{projects.map((p) => <option key={p.id} value={p.name} />)}</datalist>
      {suggestions.length ? (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {suggestions.map((p) => <button key={p.id} type="button" className="chip" onClick={() => onChange(p.name)} data-testid={`song-project-${p.id}`}>{p.name.toUpperCase()}</button>)}
        </div>
      ) : null}
      {value.trim() ? (
        <div className="t-hint" data-testid="song-project-hint" style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <Icon name={hit ? "checkmark" : "add"} size={13} /> {hit ? `Associada ao projeto existente «${hit.name}».` : `Será criado o projeto novo «${value.trim()}».`}
        </div>
      ) : <div className="t-hint">Sem projeto.</div>}
    </div>
  );
}
